module.exports = __webpack_public_path__ + "img/Screen_Shot_10.8a6b5602.png";